import { ICallbackRequest } from "../../models";
import {
  IScheduleRequest,
  IScheduleResponse,
  IScheduleSecurity,
} from "../../models/schedule/ISchedule";
import { IScheduleService } from "../../models/schedule/IScheduleService";
import { IConfigOptions } from "../app.config.service";
import { DateTimeFactory } from "../dateTime.factory";
import { SecurityService } from "../security.service";

const CALLBACK_PREFIX = "Video Call: ";

export class GenesysCallbackService implements IScheduleService {
  private callbackPrefix = CALLBACK_PREFIX;

  constructor(private config: IConfigOptions) {}

  async create(
    request: IScheduleRequest,
    security: IScheduleSecurity
  ): Promise<IScheduleResponse> {
    const scheduledAt = DateTimeFactory.create(request.start).toISOString();

    const cb: ICallbackRequest = {
      queueName: this.config.pcCallbackQueueName,
      callbackUserName: this.callbackPrefix + request.customer.name.firstName,
      callbackNumbers: [
        request.customer.contact.primaryPhoneCountryCode +
          request.customer.contact.primaryPhone,
      ],
      callbackScheduledTime: scheduledAt,
      data: {
        ...request.metadata,
        ...request.customer.metadata,
      },
    };

    try {
      const response = await SecurityService.createCallback(
        security.otp,
        security.verificationCode,
        this.config.applicationId,
        cb
      );

      return {
        conferenceId: response.conferenceId,
        scheduleEntityId: response.ticketId,
        request,
      };
    } catch (ex) {
      throw ex;
    }
  }
}
